<template>

  <div>

    <LDBsTable
      url="finished-os"
      defaultSort="status"
      defaultOrder="asc"
      :columns="columns"
      :query="query"
      :clear="clear"
    >
      <div class="form-group col-lg-4">
        <label for="os">{{ $t('OS') }}</label>
        <input
          type="text"
          id="os"
          name="os"
          class="form-control"
          :placeholder="$t('ph_os')"
          v-model="query.idOs"
        >
      </div>

      <div class="form-group col-lg-4">
        <label for="garage_accredited">{{ $t('garage_accredited') }}</label>
        <Combobox
          class="bg-white"
          name='garage_accredited'
          :placeholder="$t('select_a_item')"
          :options="garages"
          :initial-value="query.garageAccredited"
          label="fantasyName"
          v-model="query.garageAccredited"
          :reduce="garage => garage.id"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="available_for_extract">{{ $t('available_for_extract') }}</label>
        <Combobox
          class="bg-white"
          name='available_for_extract'
          :placeholder="$t('select_a_item')"
          :options="[{ label: 'SIM', value: true }, { label: 'NÃO', value: false }]"
          :initial-value="query.availableForExtract"
          label="label"
          v-model="query.availableForExtract"
          :reduce="available => available.value"
        />
      </div>
    </LDBsTable>

    <!-- MODAL -->
    <div
      ref='modalOs'
      id="myModal"
      class="modal fade bd-example-modal-lg"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModal"
      aria-hidden="true"
    >
      <div class="modal-xl modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabel"></h5>
          </div>

          <div class="modal-body">
            <b-alert
              :show="alert.show"
              @dismissed='alert.show = false'
              dismissible
              fade
              :variant="alert.type"
            >
              {{ alert.message }}
            </b-alert>

            <div class="row">
              <div class="form-group col-lg-6">
                <label for="reason_extra_value">{{ $t('reason_extra_value') }}</label>
                <input
                  type="reason_extra_value"
                  class="form-control"
                  id="reason_extra_value"
                  name="reason_extra_value"
                  :placeholder="$t('ph_reason_extra_value')"
                  v-model="reasonExtraValue"
                >
              </div>

              <div class="form-group col-lg-6">
                <label for="extra_value_not_linked_os">{{ $t('extra_value_not_linked_os') }}</label>
                <CurrencyInput
                  v-model="extraValueNotLinkedOs"
                  :auto-decimal-mode="true"
                  :distraction-free='false'
                  currency='BRL'
                  locale='pt-BR'
                  class="demo__currency-input form-control"
                />
              </div>
            </div>

            <b-table
              id='tableModal'
              responsive='xl'
              bordered
              hover
              :fields="fieldsSubTable"
              :items='finishedOsFiltered'
              class="bg-white"
              :busy='busy'
              :tbody-tr-class="rowClass"
            >
              <template v-slot:cell(show_details)=value>
                <b-form-checkbox
                  :id="'check'+value.item.id"
                  :name="'checkbox'+value.item.id"
                  :checked='value.item.availableForExtract'
                  :disabled='!value.item.availableForExtract'
                  @change='check(value.item.id, "selectOs")'
                />
              </template>

              <template v-slot:cell(serial)=value>
                {{ getInfoIdAndEquipment(value) }}
              </template>

              <template v-slot:cell(testDate)=value>
                {{ formatDate(value.item.testDate) }}
              </template>

              <template v-slot:cell(service_value)=value>
                <CurrencyInput
                  :id="'serviceValue'+value.item.id"
                  :value='value.item.serviceValue'
                  currency='BRL'
                  :distraction-free='false'
                  :auto-decimal-mode='true'
                  locale='pt-BR'
                  class="demo__currency-input form-control"
                  style='width: 125px'
                />
              </template>

              <template v-slot:cell(travel_value)=value>
                <CurrencyInput
                  :id="'travelValue'+value.item.id"
                  :value='value.item.travelValue'
                  currency='BRL'
                  :distraction-free='false'
                  :auto-decimal-mode='true'
                  locale='pt-BR'
                  class="demo__currency-input form-control"
                  style='width: 120px'
                />
              </template>

              <template v-slot:cell(extra_value)=value>
                <CurrencyInput
                  :id="'extraValue'+value.item.id"
                  :value='value.item.extraValue'
                  currency='BRL'
                  :distraction-free='false'
                  :auto-decimal-mode='true'
                  locale='pt-BR'
                  class="demo__currency-input form-control"
                  style='width: 120px'
                />
              </template>

              <template v-slot:cell(availableForExtract)=value>
                <div class="text-center align-center">
                  <b-form-checkbox
                    :id="'availableForExtract'+value.item.id"
                    :name="'availableForExtract'+value.item.id"
                    :checked='value.item.availableForExtract'
                    @change='check(value.item.id, "availableForExtract")'
                  />
                </div>
              </template>

              <template v-slot:table-busy>
                <div class="text-center text-secondary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong> Carregando...</strong>
                </div>
              </template>

            </b-table>

            <div class="row text-right">
              <div class="col-12">
                <b-button class="mt-3" id='closeModal' data-dismiss="modal">{{ $t('close') }}</b-button>
                <b-button class="mt-3 ml-2" variant='primary' @click="save">{{ $t('save') }}</b-button>
                <b-button class="mt-3 ml-2" variant='primary' @click="generateExtractForOs">{{ $t('generate_extract') }}</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL -->
    <div
      id="modalExtractNotLinkedOs"
      class="modal fade bd-example-modal-lg"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalExtractNotLinkedOs"
      aria-hidden="true"
    >
      <div class="modal-lg modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title">Extrato não vinculado OS</h5>
          </div>

          <div class="modal-body">
            <div class="text-center" v-show="busy">
              <div class="spinner-border" role="status">
              </div>
            </div>

            <b-alert
              :show="alert.show"
              @dismissed='alert.show = false'
              dismissible
              fade
              :variant="alert.type"
            >
              {{ alert.message }}
            </b-alert>

            <div class="row" v-show="!busy">
              <div class="form-group col-lg-12">
                <label for="garage_accredited">{{ $t('garage_accredited') }}</label>
                <Combobox
                  class="bg-white"
                  name='garage_accredited'
                  :placeholder="$t('select_a_item')"
                  :options="garages"
                  :initial-value="garageSelected"
                  label="fantasyName"
                  v-model="garageSelected"
                  :reduce="garage => garage.id"
                />
              </div>

              <div class="form-group col-lg-12">
                <label for="reason_extra_value">{{ $t('reason_extra_value') }}</label>
                <input
                  type="reason_extra_value"
                  class="form-control"
                  id="reason_extra_value"
                  name="reason_extra_value"
                  :placeholder="$t('ph_reason_extra_value')"
                  v-model="reasonExtraValue"
                >
              </div>

              <div class="form-group col-lg-12">
                <label for="extra_value_not_linked_os">{{ $t('extra_value_not_linked_os') }}</label>
                <CurrencyInput
                  v-model="extraValueNotLinkedOs"
                  :auto-decimal-mode="true"
                  :distraction-free='false'
                  currency='BRL'
                  locale='pt-BR'
                  class="demo__currency-input form-control"
                />
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <b-button
              class="mt-3"
              id='closeModal'
              data-dismiss="modal"
            >
              {{ $t('close') }}
            </b-button>

            <b-button
              :disabled="!garageSelected || !reasonExtraValue || !extraValueNotLinkedOs"
              class="mt-3 ml-2"
              variant='primary'
              @click="generateExtractNotLinkedOs"
            >
              {{ $t('save') }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import LDBsTable from '@/components/shared/LDBsTable'
import Combobox from '@/components/shared/ComboBox'
import { parse } from 'vue-currency-input'
import moment from 'moment-timezone'
import { request } from '@/lib/http'

export default {
  name: 'OsList',
  components: {
    LDBsTable,
    Combobox
  },
  
  data () {
    return {
      columns: [
        {
          checkbox: true
        },
        {
          field: 'socialReason',
          title: this.$t('garage_accredited')
        },
        {
          field: 'fantasyName',
          title: this.$t('fantasy_name')
        },
        {
          field: 'totalServices',
          width: '100%',
          align: 'right',
          title: this.$t('total_services')
        },
        {
          field: 'serviceValue',
          title: this.$t('service_value'),
          width: '100%',
          align: 'right',
          formatter: function(value) {
            return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          }
        },
        {
          field: 'travelValue',
          title: this.$t('travel_value'),
          width: '100%',
          align: 'right',
          formatter: function(value) {
            return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          }
        },
        {
          field: 'extraValue',
          title: this.$t('extra_value'),
          width: '100%',
          align: 'right',
          formatter: function(value) {
            return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          }
        },
        {
          field: 'totalValue',
          title: this.$t('total_value'),
          width: '100%',
          align: 'right',
          formatter: function(value, row) {
            return (row.serviceValue + row.travelValue + row.extraValue).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          }
        },
        {
          field: 'garageAccreditedId',
          align: 'center',
          width: '100%',
          formatter: function (value, row) {
            function renderWarning() {
              if (row.travelPayment) {
                return `
                  <button
                    title="Existe OS com deslocamento"
                    class="btn btn-action btn-warning btn-circle"
                  >
                    <i class="fas fa-exclamation-triangle fa-lg" />
                  </button>
                `
              } else {
                return ``
              }
            }
            return `
              <button
                data-target="#myModal"
                data-id='${value}'
                data-toggle="modal"
                data-whatever="${row.fantasyName}"
                class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"
              >
                <i class="fas fa-eye fa-lg" />
              </button>
              ${renderWarning()}
              `
            },
        }
      ],
      query: {
        garageAccredited   : undefined,
        availableForExtract: true,
        idOs               : ''
      },
      isSelectAll: false,
      busyMain: false,
      busy: false,
      modalTitle: '',
      fieldsSubTable: [
        { key: 'show_details', label: '' },
        { key: 'serial', label: `OS / ${this.$t('serial')}`},
        { key: 'board', label: this.$t('board') },
        { key: 'client', label: this.$t('client') },
        { key: 'testDate', label: this.$t('finished_in') },
        { key: 'services.name', label: this.$t('services') },
        { key: 'service_value', label: this.$t('service_value') },
        { key: 'travel_value', label: this.$t('travel_value') },
        { key: 'extra_value', label: this.$t('extra_value') },
        { key: 'availableForExtract', label: this.$t('active') },
      ],
      alert: {
        show: false,
        type: '',
        message: ''
      },
      reloadExtracts: false,
      selected: [],
      availableForExtract: [],
      reasonExtraValue: '',
      extraValueNotLinkedOs: 0,
      garageSelected: undefined
    }
  },

  computed: {
    ...mapState({
      finishedOs        : state => state.extract.finishedOs,
      finishedOsFiltered: state => state.extract.finishedOsFiltered,
      garages           : state => state.garageaccredited.all,
    }),

    optionsCurrency() {
      return {
        locale: 'pt-BR',
        currency: 'BRL'
      }
    }
  },

  methods: {
    ...mapActions('extract', [ 'create', 'edit', 'cleanState' ]),

    clear() {
      this.query.garageAccredited    = ''
      this.query.availableForExtract = true
      this.query.idOs                = ''
    },

    getDataToSave() {
      let data = this.finishedOsFiltered.map((e, index) => {
        let serviceValue = document.querySelector(`#serviceValue${e.id}`).value
        let travelValue  = document.querySelector(`#travelValue${e.id}`).value
        let extraValue   = document.querySelector(`#extraValue${e.id}`).value

        return {
          id: e.id,
          data: {
            serviceValue       : parse(serviceValue, this.optionsCurrency) || 0,
            travelValue        : parse(travelValue, this.optionsCurrency)  || 0,
            extraValue         : parse(extraValue, this.optionsCurrency)   || 0,
            availableForExtract: e.availableForExtract
          },
          garageId: e.garageAccredited.id
        }
      })
      data[0].reasonExtraValue = this.reasonExtraValue

      return data
    },

    async save() {
      this.busy = true

      const data = this.getDataToSave()
      await this.$store.dispatch('extract/edit', data)

      this.reloadExtracts = true
      await this.$store.dispatch('extract/fetchFinishedOsFiltered', { id: data[0].garageId })
      this.alert = { show: true, type: 'success', message: 'Salvo com sucesso!' }
      this.busy = false
    },

    check(value, operation) {

      if (operation === 'selectOs') {
        if (this.selected.indexOf(value) == -1) {
          this.selected.push(value)
        } else {
          this.selected.map(e => {
            if (e == value) this.selected.splice(this.selected.indexOf(e), 1)
          })
        }
      }

      if (operation === 'availableForExtract') {
        this.finishedOsFiltered.map((e, index) => {
          if (e.id === value) this.finishedOsFiltered[index].availableForExtract = !this.finishedOsFiltered[index].availableForExtract
        })
      }
      
    },

    async generateExtractForOs() {

      if (this.selected.length == 0) {
        return this.alert = {
          show: true,
          type: 'danger',
          message: 'Selecione pelo menos 1 (uma) OS'
        }
      }
      
      this.busy = true

      const data = this.getDataToSave()
      const edit = await this.$store.dispatch('extract/edit', data)

      if (edit) {
        await this.create({ osIdsToGenerate: this.selected, extraValueNotLinkedOs: this.extraValueNotLinkedOs * 1 })
        this.reloadExtracts = true
        this.busy = false
        $("#closeModal").trigger("click")
        this.checkAll()
      } else {
        this.alert = { show: true, type: 'danger', message: 'Erro ao gerar extrato!' }
        this.busy = false
      }

    },

    async getOsFiltered(id) {
      this.busy = true
      await this.$store.dispatch('extract/fetchFinishedOsFiltered', { id, availableForExtract: this.query.availableForExtract })
      this.finishedOsFiltered.map(e => {
        if (e.availableForExtract) this.selected.push(e.id)
      })
      this.reasonExtraValue = this.finishedOsFiltered[0].reasonExtraValue
      this.busy = false
    },

    formatDate(date) {
      return moment(date).tz('America/Recife').format('DD/MM/YYYY')
    },

    reloadFinishedOs() {
      if (this.reloadExtracts)  $('#search').trigger('click')
      this.selected = []
      this.reloadExtracts = false
      this.alert = { show: false }
      this.checkAll()
    },

    async generateExtractForGarage() {
      const garagesSelected = $('#table').bootstrapTable('getSelections')
      
      const garagesIdsToGenerate = garagesSelected.map(e => {
        return {
          garageAccreditedId: e.garageAccreditedId,
          serviceValue: e.serviceValue,
          travelValue: e.travelValue,
          extraValue: e.extraValue
        }
      })

      if (garagesIdsToGenerate.length == 0) {
        return this.$store.dispatch('notify/error', { message: 'noGarageSelected' }, { root: true })
      }
      const created = await this.create({ garagesIdsToGenerate })

      return created
        ? this.$router.push({ name: 'listextracts' })
        : this.$store.dispatch('notify/error', { message: 'noOsAvailable' }, { root: true })

    },

    checkAll() {
      setTimeout(() => {
        $('#table').bootstrapTable('checkAll')
      }, 1000)
    },

    getInfoIdAndEquipment({ item }) {

      const {
        id,
        services,
        withdrawnSerial,
        serial,
        equipmentUsedInReinstallation,
        requireSerial
      } = item

      let equipment = 0

      if (services.id === 2 || services.id === 6) {
        if (!requireSerial) {
          equipment = withdrawnSerial
        } else {
          equipment = equipmentUsedInReinstallation
            ? serial
            : withdrawnSerial
        }
      } else {
        equipment = services.id === 4
          ? withdrawnSerial
          : serial
      }

      return id +" / "+ equipment
    },

    rowClass(item, type) {
      if (!item) return
      if (item.travelPayment) return 'table-warning'
    },

    async generateExtractNotLinkedOs() {
      this.busy = true

      try {
        const created = await request({
          url   : 'extract-not-linked-os',
          method: 'post',
          data  : {
            garageAccredited     : this.garageSelected,
            reasonExtraValue     : this.reasonExtraValue,
            extraValueNotLinkedOs: this.extraValueNotLinkedOs
          }
        })

        $('#modalExtractNotLinkedOs').modal('hide')
      } catch (error) {
        this.alert = {
          show: true,
          type: 'danger',
          message: error.message
        }
      } finally {
        this.busy = false
      }
    }
  },

  async mounted() {
    const { dispatch } = this.$store

    dispatch('overlay/show', true)

    await dispatch('extract/fetchFinishedOs')
    await dispatch('garageaccredited/fetchAll')

    dispatch('overlay/show', false)
    
    $('#toolbar').find('div:first').append(`<button id="generate" class="btn btn-primary text-white right" aria-expanded="true">${this.$t('generate_extract')}</button>`)

    const global = this
    $('#myModal').on('show.bs.modal', function (event) {
      var button = $(event.relatedTarget) 
      var recipient = button.data('whatever')
      var modal = $(this)
      modal.find('.modal-title').text('Ordens de Serviço - ' + recipient)
      global.getOsFiltered(button.data('id'))
    })

    $('#myModal').on('hide.bs.modal', function () {
      global.reasonExtraValue = ''
      global.extraValueNotLinkedOs = 0
      global.reloadFinishedOs()
    })

    $('#generate').on('click', function() {
      global.generateExtractForGarage()
    })

    this.checkAll()
    $('#table').bootstrapTable('checkAll')

    $('#showModalExtractNotLinkedOs').on('click', function() {
      $('#modalExtractNotLinkedOs').modal('show')
    })

    $('#modalExtractNotLinkedOs').on('hide.bs.modal', function() {
      global.garageSelected        = undefined
      global.reasonExtraValue      = ''
      global.extraValueNotLinkedOs = 0
    })

  },

  destroyed() {
    this.cleanState
  },
}

</script>